const isAbsoluteUrl = (value) => /^https?:\/\//i.test(String(value || "").trim());

export const stripNewPrefix = (pathname = "/") => {
  return String(pathname || "/") || "/";
};

export const resolveLegacyUrl = (targetPath = "/", options = {}) => {
  const rawTarget = String(targetPath || "/");
  if (isAbsoluteUrl(rawTarget)) {
    return rawTarget;
  }

  const hashSplit = rawTarget.split("#");
  const pathAndQuery = hashSplit[0] || "/";
  const explicitHash = hashSplit.length > 1 ? `#${hashSplit.slice(1).join("#")}` : "";
  const querySplit = pathAndQuery.split("?");
  const pathname = stripNewPrefix(querySplit[0] || "/");
  const explicitQuery = querySplit.length > 1 ? `?${querySplit.slice(1).join("?")}` : "";

  const search = explicitQuery || options.search || "";
  const hash = explicitHash || options.hash || "";

  if (typeof window === "undefined") {
    return `${pathname}${search}${hash}`;
  }

  const { protocol, hostname, port, origin } = window.location;
  const isLocalDevHost = hostname === "localhost" || hostname === "127.0.0.1";
  if (isLocalDevHost) {
    return `${protocol}//${hostname}:${port}${pathname}${search}${hash}`;
  }

  return `${origin}${pathname}${search}${hash}`;
};
